export default {options:{},children:[{options:{key:'members',type:'value'}},{options:{key:'team',type:'value'}}]}